var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small-program"},[(_vm.status === 0)?_c('list'):(_vm.status > 0)?_c('mini-program-authorize-info',{attrs:{"title":"小程序资料暂不可用","content":"当小程序审核成功后，小程序资料才能被启用"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }